import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseGetAll } from '../../services';

export const fetchShowcaseGetAll = createAsyncThunk(
    'showcaseGetAll/fetchShowcaseGetAll',
    async () => {
        const response = await ShowcaseGetAll()
        return response.result
    }
);

const showcaseGetAllSlice = createSlice({
    name: 'showcaseGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseGetAllSlice.reducer;
